export default __webpack_public_path__ + "static/media/pandora_small.87279703.png";